import { makeStyles } from "@material-ui/core";
import trackCardPoster from '../../assets/coverBackground/trackCardPoster.png';
import howItWorksCardLogo from '../../assets/logo/trackLogos/howItWorksCardLogo.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookSquare, faAmazon, faApple, faGoogle } from "@fortawesome/free-brands-svg-icons";
import netFlixIcon from '../../assets/tracks/nOfNetFlix.svg';
import React from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',
        width: '100%',
    },
    highlightText: {
        color: '#315CD5'
    },
    cardContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem',
        justifyContent: 'space-around',
        padding: '1rem'
    },
    card: {
        [theme.breakpoints.down("xs")]: {
            width: '90%',
            height: '13rem'
        },
        textAlign: 'start',
        padding: '2rem',
        background: '#fff',
        width: '14rem',
        height: '14rem',
        borderRadius: '10px',
    },
    containerWithCoverPhoto: {
        textAlign: 'center',
        backgroundSize: 'contain',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        color: '#fff',
    },
    faangLogoContainer: {
        display: 'inline-flex',
        gap: '1rem',
        '& svg': {
            fontSize: '1.5rem',
            color: '#fff'
        }
    }
}))

const HowItWorks = ({ ourProcesses }) => {

    const classes = useStyles();

    return (
        <section className={classes.root}>
            <h1>How it Works?</h1>
            <p>Our interview preparation process is <b className={classes.highlightText}>proven and personalized</b> to your strengths and weaknesses.</p>
            <div className={classes.cardContainer}>
                {
                    ourProcesses?.map((ourProcess, idx) => (
                        <div className={classes.card} key={ourProcess.content + '' + idx}>
                            <h4>{ourProcess.stepTitle}</h4>
                            <p>{ourProcess.stepDescription}</p>
                        </div>
                    ))
                }
                <div
                    className={`${classes.card} ${classes.containerWithCoverPhoto}`}
                    style={{ backgroundImage: "url(" + trackCardPoster + ")" }}
                >
                    <img src={howItWorksCardLogo} />
                    <p>Get your FAANG Dream Job!</p>
                    <div className={classes.faangLogoContainer}>
                        <FontAwesomeIcon icon={faFacebookSquare} />
                        <FontAwesomeIcon icon={faAmazon} />
                        <FontAwesomeIcon icon={faApple} />
                        <img src={netFlixIcon} />
                        <FontAwesomeIcon icon={faGoogle} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HowItWorks;